/**
 * ConsolidadoQtdeReport - Consolidated quantities per count
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

// N151: "Código" era o ID da contagem, e o cliente esperava ali o código do
// hospital NO SISTEMA DELE (Cód. ERP do vínculo Hospital/Cliente). O ID virou
// "Contagem" — sem ele não dá para rastrear qual contagem gerou a linha.
const columns: Column[] = [
  { key: 'codigo', label: 'Contagem', align: 'center', width: '80px' },
  { key: 'hospital_codigo', label: 'Código', align: 'center', width: '110px' },
  { key: 'hospital_nome', label: 'Hospital', width: '200px' },
  { key: 'data_hora', label: 'Data da Contagem', width: '140px' },
  { key: 'total_sistema', label: 'Sistema', align: 'right', format: 'decimal', width: '100px' },
  { key: 'total_contado', label: 'Contado', align: 'right', format: 'decimal', width: '100px' },
  { key: 'total_sobra', label: 'Sobra', align: 'right', format: 'decimal', width: '100px' },
  { key: 'total_falta', label: 'Falta', align: 'right', format: 'decimal', width: '100px' },
  { key: 'total_segregar', label: 'Segregado', align: 'right', format: 'decimal', width: '100px' },
  { key: 'faturar', label: 'Coletado', align: 'right', format: 'decimal', width: '100px' },
  { key: 'acuracidade', label: 'Acuracidade', align: 'right', format: 'percent', width: '110px' },
  { key: 'cliente_nome', label: 'Cliente', width: '180px' },
];

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const ConsolidadoQtdeReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <RelatorioGeraisTable
      columns={columns}
      data={data}
      loading={loading}
      showTotals={true}
      emptyMessage="Nenhum dado consolidado encontrado no período selecionado."
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
};
